// extracted by mini-css-extract-plugin
export default {"sendForm":"MessageSender_sendForm__YWvWG","textarea":"MessageSender_textarea__r-kxA","button":"MessageSender_button__Fv59b"};